<template>
    <div class="card border-0">
        <div class="card-header border-0 rounded-0">
            <h3 class="mb-0 fs-5 text-white">
                <span class="fas fa-filter mr-2 fs-6" aria-hidden="true"></span>
                Filter by {{filter.display_name}}
            </h3>
        </div>
        <div class="card-body bg-gray-100">
            <div class="form-check" v-for="(item, index) in filterItems" :key="item">
                <input
                    type="checkbox"
                    :name="item+'_'+index"
                    :id="item+'_'+index"
                    class="form-check-input"
                    :checked="filterItems.length === 1 ? 'checked' : ''"
                    @change="filterChange(filter.name, item)"
                >
                <label :for="item+'_'+index" class="form-check-label">{{item}}</label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['filter','filterItems'],
        methods: {
            filterChange(filter, item){
                this.$emit('filterChange', {filter: filter, item: item});
            }
        }
    }
</script>

<style>
</style>
